import _ from 'lodash';

export const prepareTenants = values => {
  const booking = _.get(values, 'booking.object');
  const bookingPrimaryTenantId = _.get(booking, 'primaryTenant.id');
  const bookingSecondaryTenantId = _.get(booking, 'secondaryTenant.id');

  let primaryTenant: any = null;
  let secondaryTenant: any = null;

  if (values.primaryTenant === true && bookingPrimaryTenantId) {
    primaryTenant = bookingPrimaryTenantId;
  }

  if (values.secondaryTenant === true && bookingSecondaryTenantId) {
    secondaryTenant = bookingSecondaryTenantId;
  }

  /*
   If you select only the secondaryTenant checkbox,
   he must be the primaryTenant in the booking extension
  */
  if (values.primaryTenant === false && values.secondaryTenant === true) {
    primaryTenant = bookingSecondaryTenantId;
    secondaryTenant = null;
  }

  return {primaryTenant, secondaryTenant};
};

export const checkSelectedBookingRoomIsDifferent = ({
  selectedBooking,
  selectedRoom
}) =>
  selectedBooking &&
  selectedRoom &&
  _.get(selectedBooking, 'room.id') !== _.get(selectedRoom, 'object.id');

export const checkSelectedBookingRoomTypeIsDifferent = ({
  selectedBooking,
  selectedRoomType
}) =>
  selectedBooking &&
  selectedRoomType &&
  _.get(selectedBooking, 'room.roomType.id') !==
    _.get(selectedRoomType, 'object.id');
